<template>
    <nav class="flex items-stretch gap-4">
        <slot></slot>
    </nav>
</template>

<script setup lang="ts">
</script>
